import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Ecosystem from "@/components/site/Ecosystem";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import CoreBusiness from "@/components/site/CoreBusiness";
import Programs from "@/components/site/Programs";
import IndiaEducation from "@/components/site/IndiaEducation";
import FloridaCoastal from "@/components/site/FloridaCoastal";
import CorporateTraining from "@/components/site/CorporateTraining";
import StudyAbroad from "@/components/site/StudyAbroad";
import Footer from "@/components/site/Footer";
import Admin from "@/pages/Admin";

const Landing = () => {
  return (
    <div className="relative bg-background overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Ecosystem />
        <Manifesto />
        <Services />
        <CoreBusiness />
        <Programs />
        <IndiaEducation />
        <FloridaCoastal />
        <StudyAbroad />
        <CorporateTraining />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    // Anchor link handling through Lenis
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onClick);

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
